<template>
  <v-row>
    <v-col
      cols="12"
      v-if="
        annualreview.userQuestionsCompleteDate == null ||
          annualreview.managerQuestionsCompleteDate == null
      "
    >
      <single-list-item
        color="performance"
        button-text="Leave Review"
        label="Message"
        v-on:click="$router.push({ path: '/features/annual-reviews' })"
      >
        {{ message }}
      </single-list-item>
    </v-col>
    <template v-else>
      <v-col cols="12" v-if="!is_user">
        <v-card class="px-4">
          <v-row>
            <v-col cols="auto" class="my-auto">
              <v-card-text class="mt-3 mr-4">
                <v-badge color="transparent" offset-y="-10" offset-x="20">
                  <template v-slot:badge="{}">
                    <user-avatar
                      :size="50"
                      :user="annualreview.manager"
                      color="performance"
                      cssClass="text-h4"
                      textColor="white"
                    ></user-avatar>
                  </template>
                  <user-avatar
                    :size="50"
                    :user="annualreview.user"
                    color="performance"
                    cssClass="text-h4"
                    textColor="white"
                  ></user-avatar>
                </v-badge>
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-title class="text-h4 font-weight-bold">
                Review Together Before You Sign Off
              </v-card-title>
              <v-card-subtitle>
                Below is a link to your annual review meeting page. Share it
                with
                {{ annualreview.user.firstName }}!
              </v-card-subtitle>
            </v-col>
          </v-row>
          <v-card-text>
            <div class="background pa-4 rounded-lg">
              <v-list outlined class="pa-0 rounded-lg mb-2">
                <v-list-item class="pr-3">
                  <v-row>
                    <v-col cols="auto" class="my-auto subtitle-1">
                      {{ currentUrl }}
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <v-btn icon @click="copy($event, currentUrl)">
                        <v-icon>content_copy</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
              <v-tooltip
                top
                v-model="showCopied"
                :position-x="tooltipX"
                :position-y="tooltipY"
              >
                <span class="pa-2">Copied!</span>
              </v-tooltip>
              <v-icon color="primary" class="mr-2">info</v-icon>
              {{ annualreview.user.firstName }} and you can also access this
              link in the annual review management area
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <annual-review-signee-card></annual-review-signee-card>
      </v-col>
      <v-col cols="6">
        <annual-review-signee-card isManager></annual-review-signee-card>
      </v-col>
    </template>
    <v-col cols="12" v-if="!is_user">
      <v-card class="pa-4">
        <v-card-title class="secondarytext--text text-h4 font-weight-bold">
          Frequently Asked Questions
        </v-card-title>
        <v-card-text>
          <div class="font-weight-bold">
            What happens when I finalize the review?
          </div>
          <p>
            HR and/or your CoreCounts admin will receive a link to this review,
            which they can choose to review in full. Additionally, this review
            will remain in an archived state in
            {{ annualreview.user.fullName }}'s account, so you and
            {{ annualreview.user.firstName }} can review it at anytime.
          </p>
          <div class="font-weight-bold">
            Are there any additional actions required of me for this review of
            {{ annualreview.user.fullName }}?
          </div>
          <p>
            There are no additional actions required of you by CoreCounts. With
            that said, HR and/or your CoreCounts admin will be notified of the
            completion of this review and they may reach out to you if your
            review process requires additional steps.
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import AnnualReviewSigneeCard from "@/components/annualreviews/AnnualReviewSigneeCard";
export default {
  name: "AnnualReviewSignoff",
  components: { AnnualReviewSigneeCard },
  data: () => ({
    started: false,
    valid: false,
    saving: false,
    showCopied: false,
    tooltipX: 0,
    tooltipY: 0
  }),
  computed: {
    message() {
      if (this.is_user) {
        return this.annualreview.userQuestionsCompleteDate == null
          ? "Your review must be completed before you can signoff"
          : "Your manager hasn't completed their review yet. You can sign off after they've completed their review";
      } else {
        return this.annualreview.managerQuestionsCompleteDate == null
          ? "Your review must be completed before you can signoff"
          : "Your employee hasn't completed their review yet. You can sign off after they've completed their review";
      }
    },
    sectionCount() {
      return this.annualreview.sections.length;
    },
    questionCount() {
      return this.question_count;
    },
    currentUrl() {
      return window.location.href.replace("/signoff", "");
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      question_count: "annualreview/question_count",
      profile: "profile/profile",
      completed_answers: "annualreview/completed_answers",
      is_user: "annualreview/is_user"
    })
  },
  mounted() {
    this.started = this.completed_answers.length > 0;
  },
  methods: {
    copy(event, value) {
      this.tooltipX = event.clientX;
      this.tooltipY = event.clientY;

      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = value;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      this.showCopied = true;

      setTimeout(() => {
        this.showCopied = false;
      }, 2000);
    }
  }
};
</script>
